import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { CL, tokenStore, activeClient } from "./api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function formatApiError(detail) {
  if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=auth
  const [clients, setClients] = useState([]);
  const [clientId, setClientId] = useState(activeClient.get());

  const loadClients = useCallback(async () => {
    const list = await CL.listClients();
    setClients(list);
    let active = activeClient.get();
    if (!active || !list.find((c) => c.id === active)) {
      active = list[0]?.id || "";
      activeClient.set(active);
      setClientId(active);
    }
    return list;
  }, []);

  const bootstrap = useCallback(async () => {
    if (!tokenStore.get()) { setUser(false); return; }
    try {
      const u = await CL.me();
      setUser(u);
      if (u.role !== "supplier") await loadClients();
    } catch {
      tokenStore.clear();
      setUser(false);
    }
  }, [loadClients]);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const finishAuth = async (data) => {
    tokenStore.set(data.token);
    setUser(data.user);
    if (data.user.role !== "supplier") await loadClients();
  };

  const login = async (email, password) => finishAuth(await CL.login({ email, password }));
  const register = async (payload) => finishAuth(await CL.register(payload));
  const logout = async () => {
    try { await CL.logout(); } catch { /* token may already be invalid */ }
    tokenStore.clear(); activeClient.clear(); setUser(false); setClients([]); setClientId("");
  };

  const selectClient = (id) => { activeClient.set(id); setClientId(id); };

  return (
    <AuthContext.Provider value={{ user, clients, clientId, login, register, logout, loadClients, selectClient, setClients }}>
      {children}
    </AuthContext.Provider>
  );
};
